export default __webpack_public_path__ + "static/media/urlShort1.f2c70840.png";